'use client';

import React, { ReactElement, useCallback } from 'react';

interface IProps {
  href: string;
  children: ReactElement | string;
  target?: '_blank';
  className?: string;
}

export default function HubLink(props: IProps) {

  const handleClick = useCallback((e: React.MouseEvent, target: string) => {
    e.preventDefault();
    window.location.href = target;
  }, []);

  return (
    <a href={ props.href } className={ props.className } target={ props.target } onClick={(e) => handleClick(e, props.href)}>
      { props.children }
    </a>
  );
}
